import React, { useEffect, useState, useMemo, useRef } from "react";
import { connect } from "react-redux";
import styled, { createGlobalStyle } from "styled-components";
import Tabs from "app/popleads/components/ui-kit/Tabs";
import ProfileCard from "app/popleads/components/ui-kit/ProfileCard";
import { Spinner, Dropdown } from "react-bootstrap";
import { colors } from "app/popleads/components/ui-kit/colors";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import ExtensionAboutPage from "./components/ExtensionAboutPage";
import Modal from "app/popleads/components/ui-kit/Modal";
import { ExtensionProvider, useExtensionContext } from "./ExtensionContext";
import { POPUP_CONTENTS } from "./utils/constants";
import ExtensionCoursesPage from "./components/ExtensionCoursesPage";
import ExtensionDealsPage from "./components/ExtensionDealsPage";
import ExtensionNewDealPage from "./components/ExtensionNewDealPage";
import TypeTag from "app/popleads/components/ui-kit/TypeTag";
import ButtonWithLabel from "app/popleads/components/ui-kit/ButtonWithLabel";
import ExtensionCourseCard from "./components/ExtensionCourseCard";
import ExtensionDealCard from "./components/ExtensionDealCard";
import ExtensionNoteCard from "./components/ExtensionNoteCard";
import ExtensionNotesPage from "./components/ExtensionNotesPage";
import ExtensionNewTaskPage from "./components/ExtensionNewTaskPage";
import ExtensionTaskCard from "./components/ExtensionTaskCard";
import useTaskDelete from "app/popleads/hooks/useTaskDelete";
import useUnpopProfile from "app/popleads/hooks/useUnpopProfile";
import ExtensionTaskList from "./components/ExtensionTaskList";
import ExtensionFeedList from "./components/ExtensionFeedList";
import { toast } from "react-toastify";
import useGetLinkedInExtensionConfigs from "app/popleads/hooks/useGetLinkedInExtensionConfigs";
import ExtensionFilesAndAttachments from "./components/ExtensionFilesAndAttachments";
import ExtensionNewLead from "./components/ExtensionNewLead";
import ExtensionProfileTasksPage from "./components/ExtensionProfileTasksPage";
import { DealFooter } from "./components/DealFooter";
import ExtensionHeaderActions from "./components/ExtensionHeaderActions";
import { get } from "../../../popleads/networking/RequestService";
import * as auth from "../../../modules/Auth/_redux/authRedux";
import { createCookie, eraseCookie } from "app/popleads/app/functions/util";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "_metronic/_helpers";
import DOMPurify from "dompurify";
import { useSelector } from "react-redux";
import useSetProfileKeyContact from "app/popleads/hooks/useSetProfileKeyContact";
import ExtensionNotice from "./components/ExtensionNotice";

const headerHeight = 57;
//const profileContentHeight = 155;

const GlobalStyle = createGlobalStyle`
  body {
    background-color: #F8F8F8 !important;
    /* extensionu iframe'de açarken, arkaplanın şeffaf olması için ileride değiştirilecekç */
    
    @media (max-width: 450px) {
        /* Bootstrap tooltip: Ensures the tooltip and its arrow remain visible on small screens */
        .tooltip {
            .arrow,
            .tooltip-inner {
                display: block !important;
            }
        }
    }
  }
`;

const ExtensionContainer = styled.div`
    width: 375px;
    height: calc(100%);
    display: flex;
    flex-direction: column;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
`;

const ExtensionContentWrapper = styled.div`
    width: 100%;
    height: calc(100vh - ${headerHeight}px);
    background-color: #fbfcfc;
    border-radius: 0 0 8px 8px;
    padding: 12px 0px;
    position: relative;
    display: flex;
    flex-direction: column;
`;

/*const ExtensionFooter = styled.div`
    width: 100%;
    min-height: 50px;
    background-color: #fff;
    border-radius: 0 0 8px 8px;
`;*/

const ExtensionPopup = styled.div`
    width: ${(props) =>
        props.variant === "Deals" || props.variant === "Transfer Deal" || props.variant === "New Deal"
            ? "662px"
            : props.variant === "Notes"
            ? "621px"
            : props.variant === "Profile Tasks"
            ? "412px"
            : "412px"};
    height: 100%;
    background-color: #fbfcfc;
    margin-right: 8px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
`;

const ExtensionWithPopup = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-family: "Gilroy", sans-serif !important;
`;

const ExtensionPopupHeader = styled.div`
    width: 100%;
    height: 56px;
    background-color: #fff;
    padding: 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px 8px 0 0;
    border-bottom: 1px solid ${colors.neutral[100]};
`;

const ExtensionPopupHeaderTitle = styled.div`
    color: ${colors.neutral[700]};
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    letter-spacing: -0.13px;
`;

const ExtensionPopupContent = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: ${(props) =>
        props.variant === "New Deal" || props.variant === "Transfer Deal"
            ? "calc(100% - 56px)"
            : props.variant === "Deals"
            ? "calc(100% - 56px - 50px)"
            : props.variant === "Campaigns"
            ? "calc(100% - 56px - 24px)"
            : props.variant === "Notes"
            ? "calc(100% - 56px)"
            : props.variant === "New Task"
            ? "calc(100% - 56px)"
            : props.variant === "Profile Tasks"
            ? "calc(100% - 56px - 50px)"
            : "calc(100% - 56px - 50px - 24px)"};
    background-color: #fbfcfc;

    ${(props) =>
        props.variant === "New Task" || props.variant === "Notes"
            ? `border-radius: 0 0 8px 8px; 
        border-bottom: 1px solid ${colors.neutral[100]};
        overflow: hidden;`
            : ""}
`;

const ExtensionPopupFooter = styled.div`
    width: 100%;
    height: 50px;
    background-color: ${colors.white};
    padding: 8px 12px;
    border-top: 1px solid ${colors.neutral[100]};
    border-radius: 0 0 8px 8px;
`;

export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #384d567a;
    z-index: 1000;
`;

export const InputWrapper = styled.div`
    width: 100%;
    position: fixed;
    max-width: 350px;
    z-index: 1001;
    margin: 0 auto;
`;

export const ProfileLoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ isSolidBackground }) => (isSolidBackground ? "#fff" : "rgba(255, 255, 255, 0.8)")};
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
`;

const MailContentModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
`;

const MailContentContainer = styled.div`
    width: 80%;
    max-width: 800px;
    max-height: 80vh;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

const MailContentHeader = styled.div`
    padding: 16px;
    border-bottom: 1px solid ${colors.neutral[200]};
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const MailContentBody = styled.div`
    padding: 16px;
    overflow-y: auto;
    flex: 1;
    i {
        color: inherit;
        font-size: inherit;
    }
`;

export const StyledDropdownToggle = styled(Dropdown.Toggle)`
    background: none !important;
    border: none !important;
    padding: 0 !important;
    color: inherit !important;
    box-shadow: none !important;

    &:hover,
    &:active,
    &:focus {
        background: none !important;
        border: none !important;
        box-shadow: none !important;
        color: inherit !important;
    }

    &:after {
        display: none !important;
    }
`;

export const StyledDropdownMenu = styled(Dropdown.Menu)`
    padding: 8px;
    min-width: 180px;
    max-width: max-content;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 1px solid ${colors.neutral[200]};

    .dropdown-item {
        border-radius: 4px;
        padding: 8px 12px;
        font-size: 14px;

        &:hover {
            background-color: ${colors.neutral[100]};
        }

        &:active {
            background-color: ${colors.primary[100]};
            color: ${colors.primary[700]};
        }
    }

    .dropdown-divider {
        margin: 4px 0;
        border-color: ${colors.neutral[200]};
    }
`;

export const StyledDropdownItem = styled(Dropdown.Item)`
    display: flex !important;
    align-items: center !important;
    gap: 16px !important;
    svg {
        height: 16px !important;
        width: 16px !important;
    }
`;

const NotificationBubble = styled.span`
    background-color: ${colors.primary[600]};
    color: white;
    border-radius: 30px;
    padding: 0 4px;
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    min-width: 15px;
    width: max-content;
    position: absolute;
    top: -6px;
    left: 48px;
    cursor: pointer;

    &:hover {
        background-color: ${colors.primary[800]};
    }
`;

const TabWithNotification = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0 8px;
`;

const LoadingSalesNavigatorContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    padding: 20px;
`;

const LogoContainer = styled.div`
    margin-bottom: 30px;
    width: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const LoadingTextContainer = styled.div`
    margin-top: 20px;
    font-size: 14px;
    color: ${colors.neutral[600]};
`;

function ExtensionHomeContent(props) {
    const {
        selectedTab,
        popupContent,
        setState,
        profile,
        setProfile,
        isProfileLoading,
        updateProfileLoading,
        selectedModal,
        modals,
        selectedDate,
        isProfileNotFound,
        showMailModal,
        mailContent,
        closeMailModal,
        isPopitSearch,
        setNewLeadObject,
        modalMessage,
        editMode,
        refreshTaskList,
        refetchProfile,
        handleDeleteDeal,
        selectedDeal,
        initialDealObject,
        taskList,
        taskListLoading,
        fetchTaskLists,
        setSelectedDeal,
        handleUpdateProfile,
        updateProfileParams,
        isIframeOpen,
        wonDeals,
        fetchWonDealsByAccountId,
        isRedirectingToDeal,
    } = useExtensionContext();

    const { user: loggedInUser } = useSelector((state) => state.auth);

    const urlParams = new URLSearchParams(window.location.search);
    const extParam = urlParams.get("ext");

    useEffect(() => {
        // Title'ı değiştir
        document.title = "L3RN Tech";

        // Favicon'u değiştir
        const favicon = document.querySelector("link[rel*='icon']") || document.createElement("link");
        favicon.type = "image/x-icon";
        favicon.rel = "shortcut icon";
        favicon.href = "/media/l3rn-tech/L3RN-Tech-38x38px.png";
        document.getElementsByTagName("head")[0].appendChild(favicon);
    }, []);

    const popupRef = useRef(null);
    const { deleteTask } = useTaskDelete();
    const [taskToDelete, setTaskToDelete] = useState(null);
    const { unpopProfile } = useUnpopProfile(profile?.id);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const isActive = false;
    const { getConfigs } = useGetLinkedInExtensionConfigs();
    const [showFilesAndAttachments, setShowFilesAndAttachments] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);
    const previousAccountIdRef = useRef(null);

    const [isUserLoaded, setUserLoaded] = useState(0);
    const [isError, setIsError] = useState(false);
    const [isLoadingSalesNavigator, setIsLoadingSalesNavigator] = useState(false);
    const [isKeyContactModalOpen, setIsKeyContactModalOpen] = useState(false);
    const { setProfileKeyContact } = useSetProfileKeyContact();
    const mailContentRef = useRef(null);

    useEffect(() => {
        if (profile && loggedInUser) {
            const isKeyContactManager = loggedInUser?.permissions?.KEYCONTACT_MANAGER === 1;
            const showApprovalModal = profile?.keyContactStatus === 1 || profile?.keyContactStatus === 3;
            setIsKeyContactModalOpen(isKeyContactManager && showApprovalModal);
        }
    }, [profile, loggedInUser]);

    useEffect(() => {
        if (!isUserLoaded) {
            get("getLoggedinUser")
                .then(({ data: { user } }) => {
                    props.setUser(user);
                    setUserLoaded(true);
                })
                .catch((error) => {
                    setIsError(true);
                });
        }
    }, [isUserLoaded, props]);

    useEffect(() => {
        if (profile?.accountId && previousAccountIdRef.current !== profile.accountId) {
            previousAccountIdRef.current = profile.accountId;
            fetchWonDealsByAccountId(profile.accountId);
        }
    }, [profile]);

    useEffect(() => {
        if (isError) {
            toast.error("An error occurred while fetching user information.");
        }
    }, [isError]);

    useEffect(() => {
        if (refreshTaskList) {
            fetchTaskLists({ selectedDate, forceRefresh: true });
            setState((prevState) => ({
                ...prevState,
                refreshTaskList: false,
            }));
        }
    }, [refreshTaskList, selectedDate, fetchTaskLists]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const extParam = urlParams.get("ext");

        if (extParam) {
            const [, hash] = extParam.split(":");

            getConfigs().then((response) => {
                if (response?.data?.extensionSeverScriptVersion !== hash) {
                    window.parent.postMessage({ message: "MESSAGE_RELOAD_EXTENSION" }, "*");
                }
            });
        }
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const hasParam = urlParams.has("is_loading_salesnavigator");
        const paramValue = urlParams.get("is_loading_salesnavigator");
        setIsLoadingSalesNavigator(hasParam && paramValue === "true");
    }, []);

    const sendNotification = (task) => {
        window.parent.postMessage({ message: "XPIDER_MESSAGE_NOTIFICATION", task: task }, "*");
    };

    const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        return doc.body.textContent || "";
    };

    useEffect(() => {
        if (taskList?.gorev?.length > 0 || profile?.gorev?.length > 0) {
            const currentDate = new Date().getTime();
            const importantTasks =
                taskList?.gorev?.filter((task) => task && task.important === 1 && task.zaman > currentDate) || [];
            const importantProfileTasks =
                profile?.gorev?.filter((task) => task && task.important === 1 && task.zaman > currentDate) || [];
            importantTasks.forEach((task) => {
                if (task) {
                    sendNotification({
                        id: task.id,
                        profilId: task.profilId,
                        metin: stripHtmlTags(task.metin || ""),
                        zaman: task.zaman,
                        important: task.important,
                        customerHappiness: task.customerHappiness,
                        taskColour: task.taskColour,
                        assignedToIds: task.assignedToIds || [],
                        activityId: task.activityId || null,
                    });
                }
            });
            importantProfileTasks.forEach((task) => {
                if (task) {
                    sendNotification({
                        id: task.id,
                        profilId: task.profilId,
                        metin: stripHtmlTags(task.metin || ""),
                        zaman: task.zaman,
                        important: task.important,
                        customerHappiness: task.customerHappiness,
                        taskColour: task.taskColour,
                        assignedToIds: task.assignedToIds || [],
                        activityId: task.activityId || null,
                    });
                }
            });
        }
    }, [taskList, profile]);

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data.message) {
                if (event.data.message === "XPIDER_NOTIFICATION_DISPLAYED") {
                    if (event.data.counter && event.data.counter > 0) {
                        setNotificationCount(event.data.counter);
                        createCookie("XPIDER_DISPLAYED_TASKS_COUNTER", event.data.counter, 14);
                    } else {
                        setNotificationCount(0);
                        eraseCookie("XPIDER_DISPLAYED_TASKS_COUNTER");
                    }
                }
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    const handleTaskDelete = async (id) => {
        try {
            await deleteTask(id);

            fetchTaskLists({ selectedDate });
            refetchProfile();
            toast.success("Task successfully deleted");
        } catch (error) {
            toast.error("Error deleting task");
        }
    };
    const handleProfileDelete = async () => {
        try {
            const { error } = await unpopProfile();
            if (!error) {
                toast.success("Profile successfully deleted");
                refetchProfile();
            } else {
                toast.error(error);
            }
        } catch (error) {
            toast.error(error?.message || "An error occurred while deleting the profile");
        } finally {
            setIsDeleteModalOpen(false);
        }
    };

    const handleKeyContactStatusChange = async (action) => {
        setIsKeyContactModalOpen(false);
        const keyContactStatus = profile?.keyContactStatus;
        const option =
            action === "approve"
                ? keyContactStatus === 1
                    ? "enable"
                    : "disable"
                : keyContactStatus === 1
                ? "disable"
                : "enable";
        const status = action === "approve" ? (keyContactStatus === 1 ? 2 : 0) : keyContactStatus === 1 ? 0 : 2;
        const result = await setProfileKeyContact(option, status);
        if (result && result.data && result.data.profil) {
            setProfile((prevProfile) => ({
                ...prevProfile,
                keyContactStatus: result.data.profil.keyContactStatus,
            }));
            toast.success("Key-Contact status was successfully updated.");
        }
    };

    const options = useMemo(
        () => [
            { value: "Feed" },
            { value: "Profile", disabled: Boolean(isProfileNotFound) },
            {
                value: "Tasks",
                component: (
                    <TabWithNotification>
                        {" "}
                        Tasks{" "}
                        {notificationCount > 0 && (
                            <NotificationBubble
                                onClick={(e) => {
                                    e.stopPropagation();
                                    window.parent.postMessage(
                                        { message: "XPIDER_NOTIFICATION_DISPLAY_AGAIN", counter: notificationCount },
                                        "*"
                                    );
                                    eraseCookie("XPIDER_DISPLAYED_TASKS_COUNTER");
                                    setNotificationCount(0);
                                    fetchTaskLists({ selectedDate, forceRefresh: true });
                                }}
                            >
                                {" "}
                                {notificationCount}{" "}
                            </NotificationBubble>
                        )}
                    </TabWithNotification>
                ),
            },
        ],
        [isProfileNotFound, notificationCount, fetchTaskLists, selectedDate]
    );

    useEffect(() => {
        if (selectedTab === "Tasks" && !isActive) {
            fetchTaskLists({ selectedDate });
        }
    }, [selectedTab, selectedDate, isActive]);

    useEffect(() => {
        if (isLoadingSalesNavigator) {
            window.parent.postMessage(
                {
                    message: "XPIDER_MESSAGE_IFRAME_WIDTH",
                    width: 375, // En baz default değer
                },
                "*"
            );
            return;
        }

        if (isIframeOpen || isRedirectingToDeal) {
            window.parent.postMessage(
                {
                    message: "XPIDER_MESSAGE_IFRAME_WIDTH",
                    width: "100vw",
                },
                "*"
            );
            return;
        }

        if (!popupRef.current && !popupContent) {
            window.parent.postMessage(
                {
                    message: "XPIDER_MESSAGE_IFRAME_WIDTH",
                    width: 375,
                },
                "*"
            );
            return;
        }

        const POPUP_WIDTHS = {
            Deals: 662,
            "New Deal": 662,
            "Transfer Deal": 662,
            Notes: 621,
            "Profile Tasks": 412,
            default: 412,
        };

        const getPopupWidth = (contentType) => {
            if (!contentType) return 375;
            return POPUP_WIDTHS[contentType] || POPUP_WIDTHS.default;
        };

        const updateParentWidth = (width) => {
            window.parent.postMessage(
                {
                    message: "XPIDER_MESSAGE_IFRAME_WIDTH",
                    width: width + 383,
                },
                "*"
            );
        };

        const initialWidth = getPopupWidth(popupContent);
        updateParentWidth(initialWidth);

        const resizeObserver = new ResizeObserver(() => {
            const width = getPopupWidth(popupContent);
            updateParentWidth(width);
        });

        resizeObserver.observe(popupRef.current);

        return () => {
            resizeObserver.disconnect();
            if (!popupContent) {
                window.parent.postMessage(
                    {
                        message: "XPIDER_MESSAGE_IFRAME_WIDTH",
                        width: 375,
                    },
                    "*"
                );
            }
        };
    }, [popupContent, isIframeOpen, isLoadingSalesNavigator, isRedirectingToDeal]);

    const setIsPopitSearch = (isOpen) => {
        setState((prevState) => ({ ...prevState, isPopitSearch: isOpen }));
        setNewLeadObject(null);
    };

    const toggleSearch = () => {
        setIsSearchVisible(!isSearchVisible);
        setIsPopitSearch(false);
        setNewLeadObject(null);
    };

    const searchInputOptionClick = (id) => {
        window.open(`/extension?profileId=${id}`, "_blank");
    };

    useEffect(() => {
        if (showMailModal) {
            const fullSizeBtn = mailContentRef.current?.querySelector("#fullsize");

            const handleClick = () => {
                const newWindow = window.open("", "_blank");

                if (newWindow) {
                    const doc = newWindow.document;
                    const newMailContent = doc.createElement("div");
                    newMailContent.innerHTML = DOMPurify.sanitize(mailContent, { ADD_ATTR: ["target", "rel"] });

                    const subject = newMailContent.querySelector("#subject").textContent;

                    const title = doc.createElement("title");
                    title.innerText = `L3RN Tech | ${subject ? subject : "No Subject"}`;
                    doc.head.appendChild(title);

                    const favicon = doc.createElement("link");
                    favicon.rel = "icon";
                    favicon.href = "/media/l3rn-tech/L3RN-Tech-38x38px.png";
                    favicon.type = "image/x-icon";
                    doc.head.appendChild(favicon);
                    const style = document.createElement("style");
                    style.textContent = `hr {border: 0; border-top: 1px solid rgba(0, 0, 0, 0.1);}`;
                    doc.head.appendChild(style);

                    const fullsizeElement = newMailContent.querySelector("#fullsize");
                    if (fullsizeElement) fullsizeElement.remove();
                    doc.body.appendChild(newMailContent);
                }
            };

            if (fullSizeBtn) {
                fullSizeBtn.addEventListener("click", handleClick);
            }
            // Cleanup
            return () => {
                if (fullSizeBtn) {
                    fullSizeBtn.removeEventListener("click", handleClick);
                }
            };
        }
    }, [showMailModal]);

    // const getProfileContentHeight = () => {
    //     const fullName = `${profile?.ad || ""} ${profile?.soyad || ""}`;
    //     if (fullName?.length > 25) {
    //         return 189;
    //     }

    //     return 165;
    // };

    const LoadingSalesNavigator = () => {
        return (
            <LoadingSalesNavigatorContainer>
                <LogoContainer>
                    <SVG src={toAbsoluteUrl("/media/l3rn-tech/L3RNTech.svg")} height={36} />
                </LogoContainer>
                <Spinner animation="border" style={{ color: colors.l3rnTech[900] }} />
                <LoadingTextContainer>Please wait while loading..</LoadingTextContainer>
            </LoadingSalesNavigatorContainer>
        );
    };

    if (loggedInUser && loggedInUser?.company?.whitelist === 0 && extParam) {
        return <ExtensionNotice />;
    }

    return (
        <>
            <GlobalStyle />
            <ExtensionWithPopup>
                {popupContent && (
                    <ExtensionPopup ref={popupRef} variant={popupContent}>
                        <ExtensionPopupHeader>
                            <div className="d-flex align-items-center">
                                <ExtensionPopupHeaderTitle>
                                    {popupContent === POPUP_CONTENTS.NEW_TASK && editMode
                                        ? POPUP_CONTENTS.EDIT_TASK
                                        : popupContent}
                                </ExtensionPopupHeaderTitle>
                                {popupContent === POPUP_CONTENTS.NOTES && (
                                    <div className="d-flex align-items-center">
                                        <ButtonWithLabel
                                            icon="attach_file"
                                            iconType="material"
                                            variant="primary"
                                            buttonStyle="borderless"
                                            label={`${profile?.attachments?.length || 0} Attached Files`}
                                            style={{ fontSize: "12px" }}
                                            onClick={() => setShowFilesAndAttachments(!showFilesAndAttachments)}
                                            hover={false}
                                        />
                                    </div>
                                )}
                            </div>
                            <ButtonWithText
                                icon="close"
                                iconType="material"
                                variant="passive"
                                size="medium"
                                buttonStyle="borderless"
                                hover={false}
                                onClick={() => {
                                    setState((prevState) => ({
                                        ...prevState,
                                        popupContent: null,
                                        editMode: false,
                                        dealObject: initialDealObject,
                                    }));
                                    setShowFilesAndAttachments(false);
                                    setSelectedDeal(null);
                                }}
                            />
                        </ExtensionPopupHeader>
                        <ExtensionPopupContent variant={popupContent}>
                            {popupContent === POPUP_CONTENTS.ABOUT ? (
                                <ExtensionAboutPage />
                            ) : popupContent === POPUP_CONTENTS.COURSES ? (
                                <ExtensionCoursesPage />
                            ) : popupContent === POPUP_CONTENTS.DEALS ? (
                                <ExtensionDealsPage wonDeals={wonDeals} />
                            ) : popupContent === POPUP_CONTENTS.NEW_DEAL ? (
                                <ExtensionNewDealPage wonDeals={wonDeals} />
                            ) : popupContent === POPUP_CONTENTS.TRANSFER_DEAL ? (
                                <ExtensionNewDealPage wonDeals={wonDeals} />
                            ) : popupContent === POPUP_CONTENTS.NOTES ? (
                                showFilesAndAttachments ? (
                                    <ExtensionFilesAndAttachments
                                        onBack={() => setShowFilesAndAttachments(false)}
                                        showBackButton={true}
                                    />
                                ) : (
                                    <ExtensionNotesPage />
                                )
                            ) : popupContent === POPUP_CONTENTS.NEW_TASK ? (
                                <ExtensionNewTaskPage />
                            ) : popupContent === POPUP_CONTENTS.PROFILE_TASKS ? (
                                <ExtensionProfileTasksPage />
                            ) : (
                                <h1>Feed</h1>
                            )}
                        </ExtensionPopupContent>
                        {popupContent === "Deals" && (
                            <ExtensionPopupFooter>
                                <DealFooter />
                            </ExtensionPopupFooter>
                        )}
                        {popupContent === "Profile Tasks" && (
                            <ExtensionPopupFooter>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <div></div>
                                    <ButtonWithText
                                        variant="primary"
                                        size="small"
                                        buttonStyle="default"
                                        onClick={() => {
                                            setState({
                                                popupContent: POPUP_CONTENTS.NEW_TASK,
                                                taskPage: false,
                                                editMode: false,
                                            });
                                        }}
                                    >
                                        Add New Task
                                    </ButtonWithText>
                                </div>
                            </ExtensionPopupFooter>
                        )}
                    </ExtensionPopup>
                )}
                <ExtensionContainer>
                    {isLoadingSalesNavigator ? (
                        <LoadingSalesNavigator />
                    ) : (
                        <>
                            <ExtensionHeaderActions
                                isSearchVisible={isSearchVisible}
                                setIsDeleteModalOpen={setIsDeleteModalOpen}
                                toggleSearch={toggleSearch}
                                setIsPopitSearch={setIsPopitSearch}
                                isPopitSearch={isPopitSearch}
                                searchInputOptionClick={searchInputOptionClick}
                                profile={profile}
                            />

                            <ExtensionContentWrapper>
                                <>
                                    {(isProfileLoading || updateProfileLoading) && (
                                        <ProfileLoadingOverlay isSolidBackground={profile ? false : true}>
                                            <Spinner animation="border" style={{ color: colors.l3rnTech[900] }} />
                                        </ProfileLoadingOverlay>
                                    )}
                                    <div
                                        style={{
                                            padding: "0px 12px",
                                            marginBottom: "25px",
                                        }}
                                    >
                                        <Tabs
                                            options={options}
                                            selected={selectedTab}
                                            setSelected={(selected) => {
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    selectedTab: selected,
                                                    popupContent: null,
                                                }));
                                            }}
                                        />
                                    </div>
                                    {selectedTab === "Profile" ? (
                                        <>
                                            <div
                                                style={{
                                                    padding: "0px 12px",
                                                    marginBottom: "25px",
                                                }}
                                            >
                                                <ProfileCard />
                                            </div>
                                            <div
                                                style={{
                                                    // height: `calc(100% - ${getProfileContentHeight()}px)`,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    flex: 1,
                                                    gap: "25px",
                                                    overflowY: "auto",
                                                    padding: "0px 12px",
                                                }}
                                            >
                                                <ExtensionCourseCard />
                                                <ExtensionDealCard />
                                                <ExtensionNoteCard
                                                    showFilesAndAttachments={showFilesAndAttachments}
                                                    setShowFilesAndAttachments={setShowFilesAndAttachments}
                                                />
                                                <TypeTag />
                                                <div>
                                                    <ExtensionTaskCard setTaskToDelete={setTaskToDelete} />
                                                </div>
                                            </div>
                                        </>
                                    ) : selectedTab === "Feed" ? (
                                        <>
                                            <ExtensionFeedList />
                                        </>
                                    ) : selectedTab === "Tasks" ? (
                                        <>
                                            <ExtensionTaskList
                                                taskList={taskList}
                                                taskListLoading={taskListLoading}
                                                setTaskToDelete={setTaskToDelete}
                                            />
                                        </>
                                    ) : (
                                        selectedTab === "New Lead" && (
                                            <>
                                                <ExtensionNewLead />
                                            </>
                                        )
                                    )}
                                </>
                            </ExtensionContentWrapper>
                        </>
                    )}
                </ExtensionContainer>
                <div id="newFilterMenu" />
            </ExtensionWithPopup>

            {showMailModal && (
                <MailContentModal onClick={closeMailModal} ref={mailContentRef}>
                    <MailContentContainer onClick={(e) => e.stopPropagation()}>
                        <MailContentHeader>
                            <h4>Email Content</h4>
                            <ButtonWithText
                                icon="close"
                                iconType="material"
                                variant="passive"
                                size="medium"
                                buttonStyle="borderless"
                                hover={false}
                                onClick={closeMailModal}
                            />
                        </MailContentHeader>
                        <MailContentBody
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(mailContent, { ADD_ATTR: ["target", "rel"] }),
                            }}
                        />
                    </MailContentContainer>
                </MailContentModal>
            )}

            <Modal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                title="Are you sure you want to delete this profile?"
                variant="danger"
                icon="delete"
                successButtonText="Yes, Delete"
                cancelButtonText="Not Now"
                onSuccess={handleProfileDelete}
            >
                <div>All related notes and tasks will be also deleted. </div>
                <div>This action cannot be undone.</div>
            </Modal>
            <Modal
                isOpen={selectedModal === modals.DELETE_TASK}
                successButtonText="Yes, Delete"
                cancelButtonText="Not Now"
                onClose={() =>
                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                    }))
                }
                title={modalMessage ? modalMessage : "Are you sure you want to delete this file?"}
                variant="danger"
                icon="delete"
                onSuccess={() => {
                    handleTaskDelete(taskToDelete);
                    refetchProfile();

                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                    }));
                }}
            >
                <div>This action cannot be undone.</div>
            </Modal>
            <Modal
                isOpen={selectedModal === modals.DELETE_DEAL}
                onClose={() =>
                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                    }))
                }
                title={
                    parseFloat(selectedDeal?.paidAmount) > 0
                        ? `This deal includes $${parseFloat(selectedDeal?.paidAmount).toFixed(
                              2
                          )} payment. Deleting it will also remove the payment permanently.`
                        : "Are you sure you want to delete this deal?"
                }
                variant="danger"
                icon="delete"
                successButtonText="Yes, Delete"
                cancelButtonText="Not Now"
                onSuccess={async () => {
                    handleDeleteDeal(selectedDeal?.id);
                }}
            >
                <div>This action cannot be undone.</div>
            </Modal>
            <Modal
                isOpen={selectedModal === modals.DELETE_BASED_ON_STATUS}
                onClose={() =>
                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                    }))
                }
                title="Delete Deal"
                variant="danger"
                icon="delete"
                successButtonText="Okay"
                onSuccess={() => {
                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                    }));
                }}
            >
                <div>Deal cannot be deleted without status cancelled</div>
            </Modal>
            <Modal
                isOpen={selectedModal === modals.LINKEDIN_URL_UPDATE}
                onClose={() =>
                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                        updateProfileParams: null,
                    }))
                }
                title="Are you sure you want to change the LinkedIn URL of this profile?"
                variant="warning"
                icon="warning"
                successButtonText="Yes"
                cancelButtonText="No"
                onSuccess={() => {
                    setState((prevState) => ({
                        ...prevState,
                        selectedModal: null,
                    }));
                    handleUpdateProfile({
                        field: updateProfileParams.field,
                        fieldValue: updateProfileParams.fieldValue,
                    });
                }}
            >
                <div>The LinkedIn URL will be updated to "{updateProfileParams?.fieldValue}"</div>
            </Modal>
            <Modal
                isOpen={isKeyContactModalOpen}
                onClose={() => setIsKeyContactModalOpen(false)}
                title={
                    profile?.keyContactStatus === 1
                        ? "Do you approve to set this profile as Key-Contact?"
                        : "Do you approve to remove Key-Contact from this profile?"
                }
                variant="primary"
                icon="link"
                successButtonText="Approve"
                cancelButtonText="Cancel"
                rejectButtonText="Decline"
                onSuccess={() => handleKeyContactStatusChange("approve")}
                onReject={() => handleKeyContactStatusChange("decline")}
            />
        </>
    );
}

function ExtensionHome(props) {
    return (
        <ExtensionProvider extensionEvents={{}}>
            <ExtensionHomeContent {...props} />
        </ExtensionProvider>
    );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = { ...auth.actions };

export default connect(mapStateToProps, mapDispatchToProps)(ExtensionHome);
